export const legacyAgentLinkTarget = (splat: string) => {
  const [agentId, proposalId] = splat.split("/").filter(Boolean);

  if (!agentId) return { to: "/byggeradar" } as const;

  if (proposalId) {
    return {
      to: "/byggeradar/agent/$agentId/$proposalId",
      params: { agentId, proposalId },
    } as const;
  }

  return { to: "/byggeradar/agent/$agentId", params: { agentId } } as const;
};
